<p>my-page works!</p>

<p>{{'MENU.DASHBOARD' | translate}}</p>
